import Modal from './components/Modal';

function init() {
  document.querySelectorAll('button[data-resource-download]').forEach(button => {
    button.addEventListener('click', openForm);
  });
}

function openForm(e) {
  const resourceId = e.target.dataset.resourceDownload;
  
  if (!resourceId) { return; }
  
  const modalContents = buildModalContents(resourceId);
  modalContents && Modal.open(modalContents);
}

function buildModalContents(resourceId) {
  const formEl = document.getElementById('resourceDownloadForm');
  
  if (!formEl) {
    console.error("Could not find download form.");
    return;
  }
  
  const formIdInput = formEl.querySelector('.gfield--type-hidden input');
  
  if (!formIdInput) {
    // A hidden form ID field is required.
    console.error("No form ID input found");
//    return null;
  }

  resourceId && (formIdInput.value = `docid:${ resourceId }`);
  
  formEl.style.display = null;
  return formEl;
}

export default { init };